import React, { useEffect } from 'react';

const AdvertComponent = ({ height, width }) => {
  // useEffect(() => {
  //   (window.adsbygoogle = window.adsbygoogle || []).push({});
  // }, []);

  return (
    <div>
  <p>---------------------------------</p>
    
  
    </div>
  );
};

export default AdvertComponent;

